const DEITY_MATCHERS = {
  vishnu:    /vishnu|perumal|ranganatha|krishna|narasimha|padmanabha|venkateswara|guruvayurappan|parthasarathy|vallabha|cheluvanarayana/i,
  shiva:     /shiva|nataraja|lingam|mahadeva|eswarar|eswaran|eswara|vadakkumnathan|virupaksha|manjunatha|kalahastiswara/i,
  muruga:    /muruga|subramanya|kartikeya/i,
  navagraha: /navagraha/i,
};

export function filterTemples(temples, { faithSet, filterValue, filterField = 'city', search, deity = 'all' }) {
  if (!temples) return [];
  return temples.filter(t => {
    if (!faithSet.has(t.faith)) return false;
    if (filterValue && filterValue !== 'all' && t[filterField] !== filterValue) return false;
    if (deity && deity !== 'all' && t.faith === 'hindu') {
      const matcher = DEITY_MATCHERS[deity];
      if (matcher && !matcher.test(t.deity_en || '')) return false;
    }
    if (search && search.trim()) {
      const q = search.trim().toLowerCase();
      const haystack = [t.name_en, t.name_hi, t.city, t.district, t.deity_en, t.deity_hi].join(' ').toLowerCase();
      if (!haystack.includes(q)) return false;
    }
    return true;
  });
}

export function getCities(temples) {
  if (!temples) return [];
  return [...new Set(temples.map(t => t.city))].sort();
}

export function getDistricts(temples) {
  if (!temples) return [];
  return [...new Set(temples.map(t => t.district))].sort();
}

export function getStats(temples) {
  if (!temples) return { total:0, hindu:0, buddhist:0, jain:0, alzhwar:0, nayanmars:0 };
  return {
    total:     temples.length,
    hindu:     temples.filter(t => t.faith === 'hindu').length,
    buddhist:  temples.filter(t => t.faith === 'buddhist').length,
    jain:      temples.filter(t => t.faith === 'jain').length,
    alzhwar:   temples.filter(t => t.alzhwar_star).length,
    nayanmars: temples.filter(t => t.nayanmars_star).length,
  };
}
